// extracted by mini-css-extract-plugin
module.exports = {"loginInputWrapper":"styles_loginInputWrapper__FkhhU","loginButtonWrapper":"styles_loginButtonWrapper__1rOHr"};